






















































































import { Component, Prop, Mixins } from "vue-property-decorator";
import {
  Project,
  ProjectProperty,
  ProjectTaskDefault
} from "../../api/project-api";
import StaffListItem from "../StaffListItem.vue";
import AppLocation from "../AppLocation.vue";
import { EnvironmentMixin } from "@/helpers/environment-mixin";
import { isNewProject } from "@/preferences";

@Component({
  components: {
    AppLocation,
    StaffListItem
  },
  methods: {
    isNewProject
  }
})
export default class ProjectDetails extends Mixins<EnvironmentMixin>() {
  @Prop({ required: true }) project!: Project;

  get service() {
    return this.$store.state.service;
  }

  get availableProperties(): ProjectProperty[] {
    this.project.additionalProperties.map(additionalProperty => {
      if (
        additionalProperty.value === "" &&
        additionalProperty.key.name === "TG ID"
      ) {
        additionalProperty.value = this.project.tgId;
      }
      if (
        additionalProperty.value === "" &&
        additionalProperty.key.name === "SシステムID"
      ) {
        additionalProperty.value = this.project.sSystemId;
      }
      if (
        additionalProperty.value === "" &&
        additionalProperty.key.name === "OHA No"
      ) {
        additionalProperty.value = this.project.OHANo;
      }
      return additionalProperty;
    });

    return this.project.additionalProperties.filter(
      p => !p.key.deletedAt && p.value
    );
  }

  get availableTaskDefaults(): ProjectTaskDefault[] {
    return this.project.taskDefaults.filter(item => item.value);
  }
}
